import React, { useCallback } from "react";
import { Modal } from "antd";
import api from "../../../services/api";
import { useToast } from "../../../hooks/toast";
import { IRequirement } from "../index";

interface IRemoveImpedimentProps {
  visible: boolean;
  handleClose: (activity_id?: string) => void;
  activity?: IRequirement;
}

const RemoveImpediment: React.FC<IRemoveImpedimentProps> = ({
  handleClose,
  visible,
  activity,
}) => {
  const { addToast } = useToast();

  const handleSubmit = useCallback(async () => {
    try {
      await api.patch(`/activities/${activity?.id}/remove_impediment`);
      handleClose(activity?.id);
      addToast({
        type: "success",
        title: "Impedimento removido",
        description: "O impedimento foi removido com sucesso.",
      });
    } catch (err) {
      addToast({
        type: "error",
        title: "Erro na atualização",
        description:
          "Occoreu um erro ao tentar remover o impedimento, tente novamente.",
      });
    }
  }, [addToast, activity, handleClose]);
  return (
    <Modal
      title="Remover Impedimento"
      visible={visible}
      onOk={() => handleSubmit()}
      destroyOnClose
      width={400}
      onCancel={() => handleClose()}
      getContainer={false}
    >
      Tem certeza que deseja remover o impedimento da atividade{" "}
      {`"${activity?.description}"`}?
    </Modal>
  );
};

export default RemoveImpediment;
